import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'server';
import { SyncMicrosoftUserView, SyncMicrosoftGroupsView } from './types';
import { AxiosResponse } from 'axios';
import {
  syncMicrosoftUserModel,
  IsyncMicrosoftUserModel,
  syncMicrosoftGroupModel,
  IsyncMicrosoftGroupModel,
} from './models/microsoft.model';

const { model, array, maybeNull, reference } = types;
export const MicrosoftStore = model('ZoomStore', {
  syncusers: array(syncMicrosoftUserModel),
  syncgroups: array(syncMicrosoftGroupModel),
  clickedUser: maybeNull(reference(syncMicrosoftUserModel)),
  clickedGroup: maybeNull(reference(syncMicrosoftGroupModel)),
})
  .views((self) => ({
    get allsyncUsersView(): SyncMicrosoftUserView[] {
      const allsyncUsersView: SyncMicrosoftUserView[] = [];
      for (let i = 0; i < self.syncusers.length; i++) {
        allsyncUsersView.push({ ...self.syncusers[i], id: i });
      }
      return allsyncUsersView;
    },
    get allsyncGroupsView(): SyncMicrosoftGroupsView[] {
      const allsyncGroupsView: SyncMicrosoftGroupsView[] = [];
      for (let i = 0; i < self.syncgroups.length; i++) {
        allsyncGroupsView.push({ ...self.syncgroups[i], id: i });
      }
      return allsyncGroupsView;
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeUsers({ data }: AxiosResponse): IsyncMicrosoftUserModel[] {
      self.syncusers.replace(data.users);
      return self.syncusers;
    },
    normalizeGroups({ data }: AxiosResponse): IsyncMicrosoftGroupModel[] {
      self.syncgroups.replace(data.groups);
      return self.syncgroups;
    },
    clearSelected(): void {
      self.clickedUser = null;
      self.clickedGroup = null;
    },
  }))

  .actions((self) => ({
    microsoftsyncUser: flow(function* () {
      const result = yield axios
        .get<IsyncMicrosoftUserModel[]>(`apps/microsoft/users`)
        .then(self.normalizeUsers)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    microsoftreSyncUser: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncMicrosoftUserModel[]>(`apps/microsoft/sync/master`, data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    microsoftreSyncSingleUser: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncMicrosoftUserModel[]>(`apps/microsoft/sync/user`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    microsoftreSyncBulkUser: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncMicrosoftUserModel[]>(`apps/microsoft/sync/users/bulk`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    microsoftsyncGroup: flow(function* () {
      const result = yield axios
        .get<IsyncMicrosoftGroupModel[]>(`apps/microsoft/groups`)
        .then(self.normalizeGroups)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    // microsoftreSyncGroup: flow(function* () {
    //   const result = yield axios
    //     .get<IsyncMicrosoftGroupModel[]>(`apps/microsoft/sync`)
    //     .then((res) => {
    //       return res.data;
    //     })
    //     .catch((error) => {
    //       throw new Error(error);
    //     });
    //   return result;
    // }),
    microsoftreSyncGroup: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncMicrosoftUserModel[]>(`apps/microsoft/sync/master`, data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    microsoftreSyncSingleGroup: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncMicrosoftGroupModel[]>(`apps/microsoft/sync/group`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IMicrosoftStore = Instance<typeof MicrosoftStore>;
